export const email = {
  title: 'views-reset-pwd-email-title',
  desc: 'views-reset-pwd-email-desc',
  formWidth: '53%',
  tryAgainBtn: {
    title: 'views-reset-pwd-email-again',
    show: false,
  },
  count: {
    start: false,
    num: 60,
  },
  formItems: [
    {
      field: 'username',
      type: 'text',
      label: 'views-reset-pwd-email-subtit',
      errorMsg: '',
      errorShow: false,
      contentInputGroupMarginTop: '8px',
    },
  ],
};
